import React from "react";
import { Typography, Button } from "@bca/ui-library";

interface InvalidInputWarningProps {
  text: string;
  validBidAmount: number;
  setBidAmount: (value: number) => void;
}

const InvalidInputWarning: React.FunctionComponent<InvalidInputWarningProps> = ({
  text,
  validBidAmount,
  setBidAmount,
}) => {
  return (
    <Typography
      variant="body"
      color="secondary-orange"
      mt={2}
      mb={0}
      marginX={0}
    >
      {text}
      <Button
        variant="tertiary"
        p={0}
        onClick={() => setBidAmount(validBidAmount)}
        css={`
          height: 100%;
          font-weight: 400;
        `}
      >
        {`£${validBidAmount / 100}`}
      </Button>
    </Typography>
  );
};

export default InvalidInputWarning;
